import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { tokens } from "../../Common/designTokens";

const QuickFixDownloadConfirmModal = ({ open, onProceed, onClose, loading = false }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="quickfix-download-confirm-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: tokens.colors.bodyBackgroundColor,
          border: `1px solid ${tokens.colors.bodyBorderColor50}`,
          boxShadow: 24,
          p: 2,
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          id="quickfix-download-confirm-title"
          variant="h6"
          component="h2"
          sx={{ color: tokens.colors.fontColour, mb: 2, textAlign: "center", fontWeight: 700 }}
        >
          Attention
        </Typography>

        <Typography sx={{ color: tokens.colors.fontColour85, mb: 1, textAlign: "center" }}>
          No date filer is applied.
        </Typography>
        <Typography sx={{ color: tokens.colors.fontColour85, mb: 1, textAlign: "center" }}>
          The file you are about to download may be large in size (~35 MB).
        </Typography>
        <Typography sx={{ color: tokens.colors.fontColour85, mb: 3, textAlign: "center" }}>
          Do you want to continue downloading?
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={loading}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: tokens.colors.fontColour,
              borderColor: tokens.colors.bodyBorderColor50,
              "&:hover": {
                borderColor: tokens.colors.bodyBorderColor50,
                backgroundColor: tokens.colors.defaultGridHoverColor,
              },
              width: "140px",
              borderRadius: "8px",
            }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={onProceed}
            disabled={loading}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: tokens.palette.primary,
              "&:hover": { backgroundColor: tokens.palette.primaryA80 },
              width: "140px",
              color: tokens.colors.white,
              borderRadius: "8px",
            }}
          >
            Proceed
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuickFixDownloadConfirmModal;
